(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/physical-tickets-provider.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/physical-tickets-provider.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  createContext = _React.createContext,
  useEffect = _React.useEffect,
  useReducer = _React.useReducer;
const _svs$ticket_partner$p = svs.ticket_partner.physicalTickets,
  reducer = _svs$ticket_partner$p.reducer,
  initialState = _svs$ticket_partner$p.initialState;
const LOCAL_STORAGE_EXPIRATION_TIME = 60 * 60 * 1000;
const PHYSICAL_TICKETS_LOCAL_STORAGE_KEY = svs.ticket_partner.constants.localStorageKey.PHYSICAL_TICKETS_LOCAL_STORAGE_KEY;
const PhysicalTicketsContext = createContext();
const PhysicalTicketsProvider = _ref => {
  let children = _ref.children;
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.hooks.useLocalStorage(PHYSICAL_TICKETS_LOCAL_STORAGE_KEY, false, LOCAL_STORAGE_EXPIRATION_TIME),
    _svs$ticket_partner$s2 = _slicedToArray(_svs$ticket_partner$s, 2),
    physicalTicketsState = _svs$ticket_partner$s2[0],
    setPhysicalTicketsState = _svs$ticket_partner$s2[1];
  const _useReducer = useReducer(reducer, initialState, () => physicalTicketsState || initialState(svs.ticket_partner.data.articles.ticketsPhysical)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(() => {
    setPhysicalTicketsState(state);
  }, [setPhysicalTicketsState, state]);
  return React.createElement(PhysicalTicketsContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, children);
};
svs.ticket_partner.PhysicalTicketsContext = PhysicalTicketsContext;
svs.ticket_partner.PhysicalTicketsProvider = PhysicalTicketsProvider;

 })(window);